import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Connexion réussie");
      navigate("/");
    } else setError(res.error);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4">
      <img src="https://images.unsplash.com/photo-1762968274962-20c12e6e8ecd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
      <div className="absolute inset-0 bg-background/80" />
      <div className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(var(--surface))]/90 p-8 backdrop-blur-xl">
        <Link to="/" className="font-heading text-2xl font-black tracking-tight">
          Vytali<span className="text-primary">Flix</span>
        </Link>
        <h1 className="mt-6 font-heading text-2xl font-bold">{t("auth.loginTitle")}</h1>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="mb-1 block text-sm text-muted-foreground">{t("auth.email")}</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-foreground outline-none focus:border-primary/50"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm text-muted-foreground">{t("auth.password")}</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-foreground outline-none focus:border-primary/50"
            />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button
            type="submit" disabled={loading} data-testid="login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary py-3 font-semibold text-primary-foreground transition-colors hover:bg-[hsl(var(--primary))]/90 disabled:opacity-60"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} {t("auth.loginCta")}
          </button>
        </form>

        <p className="mt-6 text-sm text-muted-foreground">
          {t("auth.noAccount")}{" "}
          <Link to="/register" className="text-primary hover:underline">{t("nav.register")}</Link>
        </p>
        <p className="mt-2 text-sm">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-muted-foreground hover:text-foreground">Mot de passe oublié ?</Link>
        </p>
      </div>
    </div>
  );
}
